import BaseFieldTooltip from './BaseFieldTooltip';

const maintainPartTab = (selectedState) => {
  const activePartId = selectedState.partId
  if (activePartId === "P05") {
    return "P01"
  } else {
    return activePartId
  }
}

function BaseFieldPulldown(props) {
  return (
    <BaseFieldTooltip isActive={props.children.length <= 1}>
      <select value={props.selectedState["fieldId"]}
        className={props.selectClassNames}
        onChange={(e) => props.onSelect({
          fieldId: e.target.value,
          partId: maintainPartTab(props.selectedState),
          sectionId: "S01",
          elementId: "E01",
        })}
      >
        { props.children }
      </select>
    </BaseFieldTooltip>
  )
}

export default BaseFieldPulldown;
